import { gql } from "@apollo/client";

export const getPredefinedDataByType = gql`
  query GetPredefinedDataByType(
    $Lname: String
    $first: Int
    $type: String!
    $after: Cursor
    $token: String!
  ) {
    GetPredefinedDataByType(
      token: $token
      first: $first
      after: $after
      type: $type
      where: { or: [{ value1ContainsFold: $Lname }] }
    ) {
      edges {
        node {
          id
          type
          index
          value1
          value2
          value3
          value4
        }
        cursor
      }
      totalCount
      pageInfo {
        endCursor
      }
    }
  }
`;

export const getPredefinedDataByTypes = gql`
  query GetPredefinedDataTypes($token: String!) {
    GetPredefinedDataTypes(token: $token)
  }
`;

export const GetServerDateAndTime = gql`
  query GetServerDateAndTime($token: String!) {
    GetServerDateAndTime(token: $token)
  }
`;

export const GetServerDateAndTimeWithoutToken = gql`
  query GetServerDateAndTimeWithoutToken($customer_id: ID!) {
    GetServerDateAndTimeWithoutToken(customer_id: $customer_id)
  }
`;

export const GetSqlNumber = gql`
  query GetSqlNumber(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $tableKey: String!
  ) {
    GetSqlNumber(
      token: $token
      customerID: $customerID
      companyID: $companyID
      tableKey: $tableKey
    ) {
      sqlNumber
      tableKey
    }
  }
`;

export const getEmpMasters = gql`
  query getEmpMasters($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      ... on EmpMaster {
        name
        empType
        customer {
          name
        }
      }
    }
  }
`;

export const AddTicket = gql`
  mutation AddTicket(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $loggedBy: ID
    $input: TicketDetails!
  ) {
    AddTicket(
      token: $token
      customerID: $customerID
      user_details: $user_details
      loggedBy: $loggedBy
      input: $input
    ) {
      ticketNo
      ticketDetails {
        id
        slNo
      }
    }
  }
`;

export const GetCustCompSubName = gql`
  query GetCustCompSubName($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsSubsidiary {
        name
      }
      ... on AtsCompany {
        name
      }
      ... on MstCustomer {
        name
      }
    }
  }
`;

export const GetTickets = gql`
  query GetTickets(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $junctionID: ID
    $siteID: ID!
    $input: TicketQuery!
    $orderBy: AtsTicketsOrder
    $name: String
    # $reason: String
    $startDate: Time
    $endDate: Time
  ) {
    GetTickets(
      token: $token
      after: $after
      first: $first
      orderBy: $orderBy
      customerID: $customerID
      companyID: $companyID
      siteID: $siteID
      subsidiaryID: $subsidiaryID
      junctionID: $junctionID
      input: $input
      startDate: $startDate
      endDate: $endDate
      where: {
        or: [
          { ticketNoContainsFold: $name }
          #  { reasonContainsFold: $reason }
        ]
      }
    ) {
      edges {
        node {
          id
          ticketNo
          ticketDate
          reason
          type
          priority
          status
          subsidiaryID
          siteID
          tableLevel
          poleNum
          closedDate
          junctionID
          closedDuration
          item {
            desc
            categoryDetails {
              categoryName
            }
          }
          itemDetails {
            id
            prodSerialNo
            vendorDetails {
              id
              desc
            }
          }
          company {
            id
            name
          }
          subsidiaryDetails {
            name
          }
          site {
            name
          }
          vendorDetails {
            id
            desc
          }
          junction {
            id
            name
          }
          loggedUser {
            name
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetCompanySqlNumberConfig = gql`
  query GetCompanySqlNumberConfig(
    $token: String!
    $customerId: ID!
    $companyID: ID!
    $finYrId: ID!
  ) {
    GetCompanySqlNumberConfig(
      token: $token
      customerId: $customerId
      companyID: $companyID
      finYrId: $finYrId
    ) {
      id
      tableKey
      tableDesc
      startNo
      currentNo
      isPrefixed
      prefixStr
      suffixStr
      separator
      prefillWithZero
      prefillWidth
      customerID
      companyID
      finYrID
    }
  }
`;

export const GetSqlNumberConfig = gql`
  query GetSqlNumberConfig($token: String!, $customerId: ID!, $finYrId: ID!) {
    GetSqlNumberConfig(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
    ) {
      id
      tableKey
      tableDesc
      startNo
      currentNo
      isPrefixed
      prefixStr
      suffixStr
      separator
      prefillWithZero
      prefillWidth
      customerID
      finYrID
    }
  }
`;

export const TicketNodeForDashBoard = gql`
  query TicketNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      ... on AtsTickets {
        ticketDate
        reason
        status
        ticketNo
        priority
        loggedBy
        loggedUser {
          name
        }
        itemDetails {
          vendorDetails {
            desc
          }
        }
        vendorDetails {
          id
          desc
        }
      }
    }
  }
`;

export const GetAssetCountsReport = gql`
  query GetAssetCountsReport(
    $token: String!
    $customerID: ID!
    $itemID: ID!
    $tableType: TableType!
    $tableID: ID!
  ) {
    GetAssetCountsReport(
      token: $token
      customerID: $customerID
      itemID: $itemID
      tableType: $tableType
      tableID: $tableID
    ) {
      companyName
      companyID
      subsidiaryDetails {
        subsidiaryName
        subsidiaryID
        siteDetails {
          siteID
          siteName
          assetCount
          workingCount
          notWorkingCount
        }
        assetCount
        workingCount
        notWorkingCount
        spanCount
      }
      assetCount
      workingCount
      notWorkingCount
      spanCount
    }
  }
`;

export const ResetEmpPassword = gql`
  mutation ResetEmpPassword(
    $token: String!
    $empID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
    $password: String!
  ) {
    ResetEmpPassword(
      token: $token
      empID: $empID
      customerID: $customerID
      user_details: $user_details
      password: $password
    )
  }
`;
